import { apiQueryFn } from "./queryFetcher";
import type { IExternalProvider } from "../components/ExternalProviders/ExternalProvider";

/**
 * The external provider's own record — who they are, whether the clinic has approved them, whether
 * they are a delegate acting for a practice.
 *
 * It answers a question almost every external surface asks, and six of them used to ask it
 * separately: the account banner, the dashboard, the referral card, the account page and its two
 * tabs each fetched `/external/identity` on mount. Loading the external dashboard made three
 * identical requests, and two of the six had independently declared the same cache key as a local
 * const — the same fetch, four times over, with nothing keeping the keys in step.
 *
 * One descriptor, one key, one request. Anything that changes the record writes it back here
 * (`setQueryData`) so every surface sees the change without a refetch.
 */
export const externalIdentityKey = ["externalProviderIdentity"] as const;

export const externalIdentityQuery = {
  queryKey: externalIdentityKey,
  queryFn: () => apiQueryFn<IExternalProvider>("/external/identity"),
};
